import type { ThemeConfig } from 'antd';
import { SOVEREIGN } from '@/features/epc/utils/epcProjectVisual';

/** Scoped Antd theme so Sovereign Emerald tokens never leak app-wide. */
export const dataTableTheme: ThemeConfig = {
  token: {
    colorPrimary: SOVEREIGN.btn,
    colorText: SOVEREIGN.ink,
    colorTextHeading: SOVEREIGN.title,
    colorBorderSecondary: SOVEREIGN.cardBorder,
    borderRadius: 12,
    fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
    controlHeight: 38,
  },
  components: {
    Table: {
      headerBg: '#F8F2E2',
      headerColor: SOVEREIGN.ink,
      headerSplitColor: 'rgba(11,59,46,0.12)',
      borderColor: 'rgba(11,59,46,0.10)',
      rowHoverBg: 'rgba(11,59,46,0.05)',
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
    },
    Select: {
      selectorBg: SOVEREIGN.inputBg,
      optionSelectedBg: 'rgba(201,169,97,0.14)',
    },
    Pagination: {
      itemActiveBg: SOVEREIGN.bottle,
      itemActiveColor: SOVEREIGN.canvas,
    },
    Input: {
      activeBg: SOVEREIGN.inputBg,
      activeBorderColor: SOVEREIGN.title,
    },
  },
};
